import { Html, html, View } from 'rune-ts';
import { shareFont } from '@services/MarppleShop/shared/typography';
import { classes, doIf } from '@services/MarppleShop/shared/util';
import {
  FormFieldControl,
  InputEditor,
} from '@services/MarppleShopStudio/shared/component/atom/Input/core/types.ts';
import klass from './input.module.scss';
import { required_html } from '@services/MarppleShopStudio/shared/component/atom/Input/core/helper.ts';

export abstract class Input_Base<T extends Partial<InputEditor>> extends View<T> implements FormFieldControl {
  override template() {
    return html`
      <div class="${klass.input_root}">
        <div class="${klass.title_wrap}">
          <div class="${klass.title} ${this.data.title_klass ?? ''}">
            <span class="${this.data.font_klass ?? shareFont('14_bold')}">${this.data.title}</span>
            ${doIf(() => {
              return required_html;
            }, !!this.data.required)}
          </div>
          ${this.titleRightHtml()}
        </div>
        <div class="${klass.input_wrap}">
          ${this.inputTemplate()}
          ${doIf(
            () => html`<span class="${klass.suffix} ${shareFont('14_medium')}">${this.data.suffix}</span>`,
            !!this.data.suffix,
          )}
        </div>
        <span
          class="${classes(klass.description, shareFont('12_medium'), {
            [klass.show]: !!this.data.description,
          })}"
          >${this.data.description}</span
        >
        <span
          class="${classes(klass.error_message, shareFont('12_medium'), {
            [klass.show]: !!this.data.error,
          })} ${klass.error_message} ${shareFont('12_medium')}"
          >${this.data.error || ''}</span
        >
      </div>
    `;
  }

  protected abstract inputTemplate(): Html | View;

  public titleRightHtml() {
    return html``;
  }

  public abstract setError(is_error: boolean, message?: string, name?: string): void;
  public abstract getName(): string;
  public abstract getValue(): unknown;
}
